import { devLog } from '@/utils'
import { toast } from '@/utils/ui'

const { cordova } = window
export const showSettings = (k, onError) => {
  if (!cordova) {
    return
  }
  cordova.plugins.settings.open(
    k,
    () => devLog('Ouverture du menu', k),
    typeof onError === 'function'
      ? onError
      : () => {
        toast.negative(`Impossible d'accéder aux paramètres`)
      }
  )
}
